import {
    SET_PAYMENT_GATEWAY_STATUS_START,
    SET_PAYMENT_GATEWAY_STATUS_SUCCESS,
    SET_PAYMENT_GATEWAY_STATUS_ERROR
} from '../../constants';
import showToaster from '../../helpers/toasterMessages/showToaster';
import { getAllPaymentMethods as query, updatePaymentGateWayStatus as mutation } from '../../lib/graphql';

export const updatePaymentGatewayStatus = (id, changes) => {
    return async (dispatch, getState, { client }) => {

        try {
            dispatch({
                type: SET_PAYMENT_GATEWAY_STATUS_START
            });

            const { data } = await client.mutate({
                mutation,
                variables: {
                    id,
                    ...changes
                },
                refetchQueries: [{ query }]
            });

            if (data?.updatePaymentGatewayStatus?.status == 200) {
                dispatch({ type: SET_PAYMENT_GATEWAY_STATUS_SUCCESS });
                showToaster({ messageId: 'paymentGatewayUpdated', toasterType: 'success' });
                return true;
            } else if (data?.updatePaymentGatewayStatus?.status != 'lastCheckoutRequired') {
                dispatch({
                    type: SET_PAYMENT_GATEWAY_STATUS_ERROR
                });

                showToaster({ messageId: 'paymentGatewayStatusFailed', toasterType: 'error' })
            } else if (data?.updatePaymentGatewayStatus?.status == 'lastCheckoutRequired') {
                dispatch({
                    type: SET_PAYMENT_GATEWAY_STATUS_ERROR
                });

                showToaster({ messageId: 'lastCheckoutRequired', toasterType: 'error' })
            }

        } catch (error) {
            dispatch({
                type: SET_PAYMENT_GATEWAY_STATUS_ERROR
            });
            showToaster({ messageId: 'paymentGatewayStatusFailed', toasterType: 'error' })
        }
    }
}